<div class="line" *ngIf="lineObject && readonly">
    <div class="data-left">
        <div class="reference">{{ lineObject.reference }}</div>
        <div class="description">{{ lineObject.description }}</div>
    </div>
    <div class="data-right">
        <div class="element-value">
            <div class="subtitle">{{'ROUTEPARTCMR.WDIMENSION.CAPTION' | translate}}</div>
            <div class="total">{{lineObject.wDimension | number}}</div>
        </div>
        <div class="element-value">
            <div class="subtitle">{{'ROUTEPARTCMR.YDIMENSION.CAPTION' | translate}}</div>
            <div class="total">{{lineObject.yDimension | number}}</div>
        </div>
        <div class="element-value">
            <div class="subtitle">{{'ROUTEPARTCMR.HDIMENSION.CAPTION' | translate}}</div>
            <div class="total">{{lineObject.hDimension | number}}</div>
        </div>
        <div class="element-value">
            <div class="subtitle" [innerHTML]="'ROUTEPARTCMR.M3.CAPTION' | translate"></div>
            <div class="total">{{lineObject.m3 | number}}</div>
        </div>
        <div class="element-value">
            <div class="subtitle">{{'ROUTEPARTCMR.QUANTITY.CAPTION' | translate}}</div>
            <div class="total">{{lineObject.quantity | number}}</div>
        </div>
        <div class="element-value expand">
            <div class="subtitle">{{'ROUTEPARTCMR.PALLETCOUNT.CAPTION' | translate}}</div>
            <div class="total">{{lineObject.palletCount | number}} {{ getResourcePalletType(lineObject.palletType)}}
            </div>
        </div>
        <div class="element-value">
            <div class="subtitle">{{'ROUTEPARTCMR.KG.CAPTION' | translate}}</div>
            <div class="total">{{lineObject.kg | number}}</div>
        </div>
    </div>

</div>

<div [formGroup]="rFormCMRDeliveryLine" class="line" *ngIf="lineObject && !readonly"
    [ngClass]="{'showDeleteButton': showDeleteButton(), 'readonly': readonly, 'expandedLine': expandedLine}">
    <div class="first-line">
        <input-component name="reference" formControlName="reference" class="value reference"
            placeholder="{{'ROUTEPARTCMR.REFERENCE.CAPTION' | translate}}" [(ngModel)]="_reference">
        </input-component>
        <input-component name="description" formControlName="description" class="value description"
            placeholder="{{'DESCRIPTION.CAPTION' | translate}}" [(ngModel)]="_description">
        </input-component>
        <input-component class="value kg" name="kg" formControlName="kg"
            placeholder="{{'ROUTEPARTCMR.KG.CAPTION' | translate}}" [(ngModel)]="_kg" [min]="0"
            type="number"></input-component>
        <div class="value button-sub-line" (click)="onExpandedLine()">
            <i aria-hidden="true" class="cercle fa fa-chevron-down nomesexpanded"></i>
            <i aria-hidden="true" class="cercle fa fa-chevron-right noexpanded"></i>
        </div>
    </div>

    <div class="second-line nomesexpanded">
        <div class="data-right">
            <div class="element-value">
                <input-component name="wDimension" formControlName="wDimension" class="value wDimension"
                    placeholder="{{'ROUTEPARTCMR.WDIMENSION.CAPTION' | translate}}" [(ngModel)]="_wDimension" [min]="0"
                    type="number"></input-component>
            </div>
            <div class="element-value">
                <input-component name="yDimension" formControlName="yDimension" class="value yDimension"
                    placeholder="{{'ROUTEPARTCMR.YDIMENSION.CAPTION' | translate}}" [(ngModel)]="_yDimension" [min]="0"
                    type="number"></input-component>
            </div>
            <div class="element-value">
                <input-component name="hDimension" formControlName="hDimension" class="value hDimension"
                    placeholder="{{'ROUTEPARTCMR.HDIMENSION.CAPTION' | translate}}" [(ngModel)]="_hDimension" [min]="0"
                    type="number"></input-component>
            </div>
            <div class="element-value">
                <input-component name="m3" formControlName="m3" class="value m3"
                    placeholder="{{'ROUTEPARTCMR.M3.CAPTION' | translate }}" [(ngModel)]="_m3" [min]="0"
                    type="number"></input-component>
            </div>

            <div class="element-value">
                <input-component name="quantity" formControlName="quantity" class="value quantity"
                    placeholder="{{'ROUTEPARTCMR.QUANTITY.CAPTION' | translate}}" [(ngModel)]="_quantity" [min]="0"
                    type="number"></input-component>
            </div>
            <div class="element-value expand">
                <div class="element-value inputPalletCount">
                    <input-component class="value palletCount" name="palletCount" formControlName="palletCount"
                        placeholder="{{'ROUTEPARTCMR.PALLETCOUNT.CAPTION' | translate}}" [(ngModel)]="_palletCount"
                        [min]="0" type="number"></input-component>
                </div>
            </div>
            <div class="element-value palletTypeZone">
                <enum-selector class="value palletType" [(ngModel)]="_palletType" [enumvalues]="enumPalletTypes"
                    [readonly]="false" placeholder="{{'ROUTEPARTCMR.PALLETTYPE.CAPTION' | translate}}"
                    name="palletType" formControlName="palletType" [translategroup]="'PALLETTYPES'"
                    [showclosebutton]="false">
                </enum-selector>
            </div>
        </div>
        <div class="deleteZone" *ngIf="!readonly">
            <button *ngIf="showDeleteButton()" class="deleteButton" (click)="onDeleteSelectedEvent(lineObject)"
                [disabled]="readonly">{{ 'DELETE.BUTTON' | translate }}</button>

            <div *ngIf="!showDeleteButton()" class="deleteForm">
                <div class="buttonZone">
                    <button class="cancelButton" (click)="onDeleteSelectedEvent(null)">{{'CANCEL.BUTTON' | translate
                        }}</button>
                    <button class="confirmButton" (click)="onDeleteLine()">{{'CONFIRM.BUTTON' | translate }}</button>
                </div>
            </div>
        </div>
    </div>
</div>
